  export const ACTIONS_LABELS = {
    CREATE_RULE: "Create TRM rule",
    ACTIVATE_RULE: "Activate TRM rule",
    DEACTIVATE_RULE: "Deactivate TRM rule",
    EDIT_RULE: "Edit rule",
    PER_WHITELISTING: "Per whitelisting",
    WHITELISTING_PER_CLIENT: "Whitelisting per client",
    REVIEW_REPORTS: "Review reports",
    REVIEW_AUDIT: "Review audit trials",
    ESCALATE: "Escalate (button)",
    AML_INCREASE_RISK: "Send to AML increase risk (button)",
    MODIFY_SETTINGS: "Modify settings",
    LOGS: "Logs",
    RESOLVE: "Resolve",
    RESOLUTION_TEXT: "Resolution text",
    DOWNLOAD_REPORT: "Download report (if applicable)",
    MANUAL_SEARCH: "Manual search (one tenant)",
    MANUAL_SEARCH_MULTI: "Manual search (multiple tenants)",
    REVIEW_MONITORING: "Review monitoring qeueu (one tenant)",
    SEARCH_REVIEW_MONITORING:
      "Search and review monitoring queue (multiple tenants)",
  };